import { render, staticRenderFns } from "./map-bottom-popup-header.vue?vue&type=template&id=542fe0f3"
import script from "./map-bottom-popup-header.vue?vue&type=script&lang=js"
export * from "./map-bottom-popup-header.vue?vue&type=script&lang=js"
import style0 from "./map-bottom-popup-header.vue?vue&type=style&index=0&id=542fe0f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports